/**
 * WISH LIST PAGE - FLO SIGNATURE DESIGN SYSTEM v2
 * Clean. Controlled. Consistent. Dark tool mode.
 */

import React from 'react';
import { Screen } from '../design/primitives';
import WishList from '../components/WishList';

const WishListPage: React.FC = () => {
  return (
    <Screen>
      <WishList />
    </Screen>
  );
};

export default WishListPage;
